export default __webpack_public_path__ + "static/media/metaforce.a1d2c228.png";